import PATH from 'routes/path';

const ClientNavList = [
  {
    title: 'Lists',
    path: `${PATH.LISTS}`
  },
  {
    title: 'Account',
    path: `${PATH.ACCOUNT}`
  },
  {
    title: 'Quick Order',
    path: `${PATH.QUICK_ORDER}`
  },
  {
    title: 'Cart',
    path: `${PATH.CART}`
  }
];

export default ClientNavList;
